export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9421.3b9a9886.jpg";